import gql from "graphql-tag"

export default gql`

  query importList {
    importCount: importList {
      id
    }
  }
`